module.exports = __webpack_public_path__ + "static/wordpress5-0620fdb1cf4f35fd29ffbc8b0199c128.png";